/* Material */
import Typo from '@mui/material/Typography'
import Button from '@mui/material/Button'
import useStyles from './styles'
import { pageBuilderButtonSx } from 'src/theme/pageBuilderButtons'

interface Props {
  retry: () => void
}

const Error: React.FC<Props> = ({ retry }) => {
  const classes = useStyles()

  return <div className={classes.error}>

    <Typo variant="h5">
      Das hat leider nicht geklappt.
    </Typo>

    <Button 
      size='large' variant='contained' color='success'
      sx={pageBuilderButtonSx}
      onClick={retry}
    >
      nocheinmal versuchen
    </Button>

  </div>
}
  
export default Error
